var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contractAdd"}},[_c('van-steps',{staticClass:"step",attrs:{"active":_vm.active,"active-color":"#FD7E2D"},on:{"click-step":function (item) {
         if (_vm.activeMax > item || _vm.activeMax == item) {
           _vm.active = item;
         }
       }}},[_c('van-step',[_vm._v("基础信息")]),_c('van-step',[_vm._v("租期信息")]),_c('van-step',[_vm._v("资产信息")]),_c('van-step',[_vm._v("附件信息")])],1),(_vm.active === 0)?_c('div',{staticClass:"form1"},[_c('van-form',{ref:"form1",attrs:{"label-width":"110px","input-align":"right"}},[_c('van-field',{attrs:{"readonly":"","clickable":!_vm.disable.house,"required":"","disabled":_vm.disable.house,"name":"house","value":_vm.houseNow.address,"label":"房源","placeholder":"点击搜索房源>","rules":[{ required: true, message: '请选择房源' }]},on:{"click":function (item) {
             if (!_vm.disable.house) {
               _vm.showHouse = true;

               _vm.searchValueHouse = '';
               _vm.showHouse;
             }
           }}}),_c('van-field',{attrs:{"name":"出租方式","label":"出租方式","required":"","rules":[{ validator: _vm.validRentType, message: '请选择预定方式' }]},scopedSlots:_vm._u([(_vm.active === 0)?{key:"input",fn:function(){return [_c('van-radio-group',{attrs:{"disabled":_vm.disable.room,"direction":"horizontal"},model:{value:(_vm.rentTypeNow),callback:function ($$v) {_vm.rentTypeNow=$$v},expression:"rentTypeNow"}},_vm._l((_vm.rentTypeList),function(item){return _c('van-radio',{key:item.roomNo,attrs:{"name":item.roomNo,"disabled":!item.show || (!item.roomNo && item.type == 2)},on:{"click":function($event){_vm.changeRentType(
                   item.roomNo,

                   !item.show || (!item.roomNo && item.type == 2)
                 )}}},[_vm._v(_vm._s(item.roomNo ? item.roomNo : "整租"))])}),1)]},proxy:true}:null],null,true)}),_c('van-field',{attrs:{"type":"number","readonly":"","name":"email","label":"租赁面积"},on:{"focus":function($event){return _vm.End($event)}},model:{value:(_vm.acreage),callback:function ($$v) {_vm.acreage=$$v},expression:"acreage"}}),_c('van-field',{attrs:{"readonly":"","clickable":!_vm.disable.customer,"required":"","disabled":_vm.disable.customer,"name":"租客手机号","value":_vm.form.customerPhone,"label":"租客手机号","placeholder":"点击搜索客户>","maxlength":"11","rules":[
           { required: true, message: '请填写手机号' },

           { validator: _vm.validPhone, message: '请输入正确手机号' } ]},on:{"click":function (item) {
             if (!_vm.disable.customer) {
               _vm.showCustomer = true;

               _vm.searchValueCustomer = '';

               _vm.customerList = [];
             }
           }}}),_c('van-field',{attrs:{"required":"","name":"name","label":"姓名","disabled":"","placeholder":"点击填写","rules":[{ required: true, message: '请填写姓名' }]},model:{value:(_vm.form.customerName),callback:function ($$v) {_vm.$set(_vm.form, "customerName", $$v)},expression:"form.customerName"}}),_c('van-field',{attrs:{"readonly":"","clickable":"","required":"","disabled":"","name":"idType","value":_vm.idTypeList[_vm.form.idType - 1],"label":"证件类型","placeholder":"点击选择>","rules":[{ required: true, message: '请选择证件类型' }]}}),_c('div',{staticClass:"field van-cell--required"},[_vm._v("签约人证件照")]),_c('div',{staticClass:"body"},[_c('div',{staticClass:"picCard"},[_c('van-uploader',{attrs:{"before-read":_vm.beforeRead,"after-read":_vm.contractFrontSuccess,"deletable":_vm.form.idType == 2 || _vm.form.idType == 3 || _vm.form.idType == 7,"max-count":1},model:{value:(_vm.contractorFront),callback:function ($$v) {_vm.contractorFront=$$v},expression:"contractorFront"}}),_c('div',{staticClass:"text"},[_c('van-field',{attrs:{"value":"正面","name":"contractorFront","disabled":"","rules":[
                 {
                   validator: function (item) {
                     return Boolean(_vm.contractorFront.length) || !_vm.imgUp;
                   },

                   message: '请上传正面图',
                 } ]}})],1)],1),_c('div',{staticClass:"picCard"},[_c('van-uploader',{attrs:{"before-read":_vm.beforeRead,"after-read":_vm.contractBackSuccess,"deletable":_vm.form.idType == 2 || _vm.form.idType == 3 || _vm.form.idType == 7,"max-count":1},model:{value:(_vm.contractorBack),callback:function ($$v) {_vm.contractorBack=$$v},expression:"contractorBack"}}),_c('div',{staticClass:"text"},[_c('van-field',{attrs:{"value":"反面","name":"contractorBack","disabled":"","rules":[
                 {
                   validator: function (item) {
                     return Boolean(_vm.contractorBack.length) || !_vm.imgUp;
                   },

                   message: '请上传反面图',
                 } ]}})],1)],1)]),_c('van-field',{attrs:{"type":"text","required":"","disabled":!(_vm.form.idType == 2 || _vm.form.idType == 3 || _vm.form.idType == 7),"name":"idNo","label":"证件号码","placeholder":"点击填写","rules":[
           { required: true, message: '请填写证件号码' },

           { validator: _vm.validIdNo1, message: '请输入正确的身份证' } ]},on:{"input":_vm.idNoChange},model:{value:(_vm.form.idNo),callback:function ($$v) {_vm.$set(_vm.form, "idNo", $$v)},expression:"form.idNo"}}),_c('van-field',{attrs:{"name":"客户类型","label":"客户类型","required":"","rules":[
           {
             validator: function (item) {
               return Boolean(_vm.form.customerType);
             },

             message: '请选择客户类型',
           } ]},scopedSlots:_vm._u([(_vm.active === 0)?{key:"input",fn:function(){return [_c('van-radio-group',{attrs:{"disabled":Boolean(_vm.$route.query.changeHouseContractId) || _vm.form.status == 3,"direction":"horizontal"},model:{value:(_vm.form.customerType),callback:function ($$v) {_vm.$set(_vm.form, "customerType", $$v)},expression:"form.customerType"}},[_c('van-radio',{attrs:{"name":1},on:{"click":function($event){return _vm.changeCustomerType(1)}}},[_vm._v("个人客户")]),_c('van-radio',{attrs:{"name":2},on:{"click":function($event){return _vm.changeCustomerType(2)}}},[_vm._v("企业客户")])],1)]},proxy:true}:null],null,true)}),(_vm.eleWaterMeterShow)?_c('van-field',{attrs:{"name":"是否自动断电","label":"是否自动断电","required":"","rules":[
           { required: true, message: '请选择是否自动断电' } ]},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('van-radio-group',{attrs:{"direction":"horizontal"},model:{value:(_vm.form.autoPowerOff),callback:function ($$v) {_vm.$set(_vm.form, "autoPowerOff", $$v)},expression:"form.autoPowerOff"}},[_c('van-radio',{attrs:{"name":0}},[_vm._v("不断电")]),_c('van-radio',{attrs:{"name":1}},[_vm._v("断电")])],1)]},proxy:true}],null,false,468225526)}):_vm._e(),(_vm.form.customerType == '2')?_c('div',{staticClass:"body"},[(_vm.form.customerType == 2)?_c('div',{staticClass:"picCard"},[_c('van-uploader',{attrs:{"before-read":_vm.beforeRead,"after-read":function (item) {
                 _vm.businessLicense = [
                   {
                     url: _vm.upload_qiniu_addr + item.file.key,

                     isImage: true,
                   } ];

                 _vm.$refs.form1.resetValidation('businessLicense');
               },"max-count":1},model:{value:(_vm.businessLicense),callback:function ($$v) {_vm.businessLicense=$$v},expression:"businessLicense"}}),_c('div',{staticClass:"text"},[_c('van-field',{attrs:{"value":"营业执照","name":"businessLicense","disabled":"","rules":[
                 {
                   validator: function (item) {
                     return (
                       (_vm.form.customerType == 2
                         ? Boolean(_vm.businessLicense.length)
                         : true) || !_vm.imgUp
                     );
                   },

                   message: '请上传营业执照图',
                 } ]}})],1)],1):_vm._e()]):_vm._e(),(_vm.form.customerType == '2')?_c('van-field',{attrs:{"required":"","name":"orgName","label":"企业名称","placeholder":"点击填写","rules":[{ required: true, message: '请填写企业名称' }]},model:{value:(_vm.form.orgName),callback:function ($$v) {_vm.$set(_vm.form, "orgName", $$v)},expression:"form.orgName"}}):_vm._e(),(_vm.form.customerType == '2')?_c('van-field',{attrs:{"required":"","name":"orgNo","label":"社会信用代码","placeholder":"点击填写","rules":[{ required: true, message: '请填写社会信用代码' }]},model:{value:(_vm.form.orgNo),callback:function ($$v) {_vm.$set(_vm.form, "orgNo", $$v)},expression:"form.orgNo"}}):_vm._e(),_c('van-field',{attrs:{"type":"email","name":"email","label":"电子邮箱","placeholder":"点击填写","rules":[{ validator: _vm.validEmail, message: '请输入正确邮箱' }]},on:{"focus":function($event){return _vm.End($event)}},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}}),_c('van-field',{attrs:{"name":"company","label":"工作单位","placeholder":"点击填写"},on:{"focus":function($event){return _vm.End($event)}},model:{value:(_vm.form.company),callback:function ($$v) {_vm.$set(_vm.form, "company", $$v)},expression:"form.company"}}),_c('van-field',{attrs:{"name":"position","label":"职位","placeholder":"点击填写"},on:{"focus":function($event){return _vm.End($event)}},model:{value:(_vm.form.position),callback:function ($$v) {_vm.$set(_vm.form, "position", $$v)},expression:"form.position"}}),_c('van-field',{attrs:{"required":"","name":"contactName","label":"紧急联系人姓名","placeholder":"点击填写","rules":[{ required: true, message: '请填写紧急联系人姓名' }]},on:{"focus":function($event){return _vm.End($event)}},model:{value:(_vm.form.contactName),callback:function ($$v) {_vm.$set(_vm.form, "contactName", $$v)},expression:"form.contactName"}}),_c('van-field',{attrs:{"readonly":"","clickable":"","required":"","name":"contactRelation","value":_vm.contactList[_vm.form.contactRelation - 1],"label":"紧急联系人关系","placeholder":"点击选择>","rules":[{ required: true, message: '请选择紧急联系人关系' }]},on:{"click":function (item) {
             if (!_vm.$route.query.changeHouseContractId) {
               _vm.showContact = true;
             }
           }}}),_c('van-field',{attrs:{"required":"","type":"tel","name":"contactPhone","label":"紧急联系人电话","placeholder":"点击填写","maxlength":"11","rules":[
           { required: true, message: '请填写紧急联系人电话' },

           { validator: _vm.validPhone, message: '请输入正确手机号' },

           {
             validator: function (item) {
               return Boolean(_vm.form.contactPhone != _vm.form.customerPhone);
             },

             message: '紧急联系人电话不可与租客相同',
           } ]},on:{"focus":function($event){return _vm.End($event)}},model:{value:(_vm.form.contactPhone),callback:function ($$v) {_vm.$set(_vm.form, "contactPhone", $$v)},expression:"form.contactPhone"}}),_c('van-field',{attrs:{"name":"persons","label":"入住人数","required":""},scopedSlots:_vm._u([(_vm.active === 0)?{key:"input",fn:function(){return [_c('van-stepper',{attrs:{"min":"0","max":"20","integer":"","disable-input":""},on:{"plus":function($event){_vm.form.customerPersonList.push({
                 name: '',

                 phone: '',
                 id: '',
                 idType: '',

                 idCard: '',

                 frontCertificateUrl: '',

                 backCertificateUrl: '',
               });

               _vm.cardList.push({
                 prevIdCard: [],

                 backIdCard: [],
               });},"minus":function($event){_vm.form.customerPersonList.pop();

               _vm.cardList.pop();}},model:{value:(_vm.form.persons),callback:function ($$v) {_vm.$set(_vm.form, "persons", $$v)},expression:"form.persons"}})]},proxy:true}:null],null,true)}),_vm._l((_vm.form.customerPersonList),function(item,index){return _c('div',{key:index,staticStyle:{"border-bottom":"0.02667rem solid #ebedf0","margin":"0.1rem 0"}},[_c('van-field',{attrs:{"required":"","readonly":"","name":'personphone' + index,"type":"tel","label":'租客' + (index + 1) + '电话',"value":item.phone,"placeholder":"点击搜索租客>","maxlength":"11","rules":[
             { required: true, message: '请填写租客' + (index + 1) + '电话' },

             { validator: _vm.validPhone, message: '请输入正确手机号' } ]},on:{"click":function (item) {
               _vm.showCheckPerson = true;

               _vm.searchValueCheckPerson = '';
               _vm.checkPersonIndex = index;
               _vm.CheckPersonList = [];
             }}}),_c('van-field',{attrs:{"readonly":"","clickable":"","disabled":"","required":"","name":'personidType' + index,"value":_vm.idTypeList[item.idType - 1],"label":'租客' + (index + 1) + '证件类型',"placeholder":"点击选择>","rules":[{ required: true, message: '请选择租客证件类型' }]},on:{"click":function (item) {
               _vm.personIndex = index;
             }}}),_c('div',{staticClass:"body"},[_c('div',{staticClass:"picCard"},[_c('van-uploader',{attrs:{"disabled":!item.name,"deletable":!(item.idType == 1) &&  !(_vm.form.customerPhone == item.phone),"before-read":_vm.beforeRead,"after-read":function (fileItem) {
                   _vm.cardList[index].prevIdCard = [
                     {
                       url: _vm.upload_qiniu_addr + fileItem.file.key + "" + (_vm.isAddTextMask?_vm.imgMaskUrl:''),

                       isImage: true,
                     } ];

                   item.frontCertificateUrl =
                     _vm.upload_qiniu_addr + fileItem.file.key;

                   _vm.$refs.form1.resetValidation('prevcard' + index);
                 },"max-count":1},model:{value:(_vm.cardList[index].prevIdCard),callback:function ($$v) {_vm.$set(_vm.cardList[index], "prevIdCard", $$v)},expression:"cardList[index].prevIdCard"}}),_c('div',{staticClass:"text"},[_c('van-field',{attrs:{"value":"正面","name":'prevcard' + index,"disabled":"","rules":[
                   {
                     validator: function (item) {
                       return (
                         Boolean(_vm.cardList[index].prevIdCard.length) || !_vm.imgUp
                       );
                     },

                     message: '请上传正面图',
                   } ]}})],1)],1),_c('div',{staticClass:"picCard"},[_c('van-uploader',{attrs:{"disabled":!item.name,"deletable":!(item.idType == 1)&&  !(_vm.form.customerPhone == item.phone),"before-read":_vm.beforeRead,"after-read":function (fileItem) {
                   _vm.cardList[index].backIdCard = [
                     {
                       url: _vm.upload_qiniu_addr + fileItem.file.key  + "" + (_vm.isAddTextMask?_vm.imgMaskUrl:''),

                       isImage: true,
                     } ];

                   item.backCertificateUrl =
                     _vm.upload_qiniu_addr + fileItem.file.key;

                   _vm.$refs.form1.resetValidation('backcard' + index);
                 },"max-count":1},model:{value:(_vm.cardList[index].backIdCard),callback:function ($$v) {_vm.$set(_vm.cardList[index], "backIdCard", $$v)},expression:"cardList[index].backIdCard"}}),_c('div',{staticClass:"text"},[_c('van-field',{attrs:{"value":"反面","name":'backcard' + index,"disabled":"","rules":[
                   {
                     validator: function (item) {
                       return (
                         Boolean(_vm.cardList[index].backIdCard.length) || !_vm.imgUp
                       );
                     },

                     message: '请上传反面图',
                   } ]}})],1)],1)]),_c('van-field',{attrs:{"required":"","disabled":item.idType == 1 || !item.phone || _vm.form.customerPhone == item.phone,"name":'personname' + index,"label":'租客' + (index + 1) + '姓名',"placeholder":"点击填写","rules":[
             { required: true, message: '请填写租客' + (index + 1) + '姓名' } ]},on:{"focus":function($event){return _vm.End($event)}},model:{value:(item.name),callback:function ($$v) {_vm.$set(item, "name", $$v)},expression:"item.name"}}),_c('van-field',{staticClass:"border",attrs:{"required":"","disabled":item.idType == 1 || !item.phone || _vm.form.customerPhone == item.phone,"name":'personidCard' + index,"label":'租客' + (index + 1) + '证件号',"maxlength":"18","placeholder":"点击填写","rules":[
             {
               required: true,

               message: '请填写租客' + (index + 1) + '身份证',
             },

             {
               validator: function (e) {
                 if (item.idType == 1) {
                   return Boolean(_vm.validIdNo(e));
                 } else {
                   return true;
                 }
               },

               message: '请输入正确的身份证',
             } ]},on:{"focus":function($event){return _vm.End($event)}},model:{value:(item.idCard),callback:function ($$v) {_vm.$set(item, "idCard", $$v)},expression:"item.idCard"}})],1)})],2),_c('div',{staticStyle:{"height":"1.2rem"}}),_c('div',{staticClass:"btn"},[_c('van-button',{attrs:{"round":"","block":"","type":"primary","disabled":_vm.nextDisabled},on:{"click":_vm.next1}},[_vm._v("下一步")])],1)],1):_vm._e(),(_vm.active === 1)?_c('div',{staticClass:"form2"},[_c('van-form',{key:"form2",ref:"form2",attrs:{"label-width":"110px","input-align":"right"}},[_c('van-field',{attrs:{"readonly":"","clickable":"","required":"","disabled":Boolean(
             (_vm.$route.query.contractId &&
               (_vm.form.type == 2 || _vm.form.status == 3)) ||
               (_vm.$route.query.oldContractId &&
                 (_vm.form.type == 2 || _vm.form.type == 3)) ||
               _vm.$route.query.prevContractId
           ),"name":"startDate","value":_vm.form.startDate ? _vm.form.startDate.slice(0, 10) : '',"label":"开始日期","placeholder":"点击选择日期>","rules":[{ required: true, message: '请选择日期' }]},on:{"click":function (item) {
             if (
               !Boolean(
                 (_vm.$route.query.contractId &&
                   (_vm.form.type == 2 || _vm.form.status == 3)) ||
                   (_vm.$route.query.oldContractId &&
                     (_vm.form.type == 2 || _vm.form.type == 3)) ||
                   _vm.$route.query.prevContractId
               )
             ) {
               _vm.startRangeDate = _vm.form.startRangeDate
                 ? new Date(_vm.form.startRangeDate.slice(0, 10))
                 : _vm.startRangeDate;

               _vm.endRangeDate = _vm.form.endRangeDate
                 ? new Date(_vm.form.endRangeDate.slice(0, 10))
                 : _vm.endRangeDate;

               _vm.showStartDate = true;
             }
           }}}),_c('van-field',{attrs:{"readonly":"","clickable":"","disabled":Boolean(
             (_vm.$route.query.contractId &&
               (_vm.form.status == 3 || _vm.form.type == 4)) ||
               _vm.$route.query.transferContractId
           ),"required":"","name":"activity","value":!_vm.form.activityId
             ? '不参加'
             : _vm.activity.name,"label":"参加活动","placeholder":"点击选择>"},on:{"click":function (item) {
             if (
               !Boolean(
                 (_vm.$route.query.contractId &&
                   (_vm.form.status == 3 || _vm.form.type == 4)) ||
                   _vm.$route.query.transferContractId
               )
             ) {
                (_vm.showActivity = true) ;
             }
           }}}),_c('van-field',{attrs:{"readonly":"","value":_vm.propertyContract.quitDate
             ? _vm.propertyContract.quitDate.slice(0, 10)
             : '',"label":"业主合约到期日"}}),_c('van-field',{attrs:{"readonly":"","value":_vm.propertyContract.number,"label":"业主合约编码"}}),_c('van-field',{attrs:{"type":"digit","name":"leaseMonth","label":"租期（月）","placeholder":"点击填写","disabled":Boolean(
             (_vm.$route.query.contractId &&
               (_vm.form.status == 3 || _vm.form.type == 4)) ||
               (_vm.$route.query.oldContractId && _vm.form.type == 3) ||
               _vm.$route.query.transferContractId ||
               !_vm.form.startDate|| this.activity.type == 3
           ),"rules":[
           {
             validator: function (item) {
               return Boolean(_vm.form.leaseMonth/1 || _vm.form.leaseDay/1);
             },

             message: '请填写租期',
           } ]},on:{"blur":function($event){_vm.getSku();

           _vm.getEndDate();
          
           _vm.$refs.form2.validate('leaseDay');},"change":_vm.changeMonth},model:{value:(_vm.form.leaseMonth),callback:function ($$v) {_vm.$set(_vm.form, "leaseMonth", $$v)},expression:"form.leaseMonth"}}),_c('van-field',{attrs:{"type":"digit","name":"leaseDay","label":"租期（天）","placeholder":"点击填写","disabled":Boolean(
             (_vm.$route.query.contractId &&
               (_vm.form.status == 3 || _vm.form.type == 4)) ||
               (_vm.$route.query.oldContractId && _vm.form.type == 3) ||
               _vm.$route.query.transferContractId ||
               !_vm.form.startDate|| this.activity.type ==3
           ),"rules":[
           {
             validator: function (item) {
               return Boolean(_vm.form.leaseMonth/1 || _vm.form.leaseDay/1);
             },

             message: '请填写租期',
           },

           {
             validator: function (item) {
               return !Boolean(_vm.leaseDayValid && _vm.form.leaseDay > _vm.leaseDayValid);
             },

             message: '当租期大于1个月时请输入月数+天数',
           } ]},on:{"change":_vm.changeMonth,"blur":function($event){_vm.getSku();

           _vm.getEndDate();

           _vm.$refs.form2.validate('leaseMonth');}},model:{value:(_vm.form.leaseDay),callback:function ($$v) {_vm.$set(_vm.form, "leaseDay", $$v)},expression:"form.leaseDay"}}),_c('van-field',{attrs:{"readonly":"","name":"endDate","disabled":"","value":_vm.form.endDate ? _vm.form.endDate.slice(0, 10) : '',"label":"结束日期","placeholder":"自动计算，不可修改","rules":[
           {
             validator: function (item) {
               if(!_vm.$route.query.changeHouseContractId){
                  return _vm.oldContract.endDate
                 ? !Boolean(_vm.oldContract.endDate > _vm.form.endDate)
                 : true;
               }else{
                 return true
               }
              
             },

             message:
               '结束日期必须大于等于上一份合约到期日（' +
               _vm.oldContract.endDate.slice(0, 10) +
               '）',
           },

           {
             validator: function (item) {
               return _vm.propertyContract.quitDate
                 ? !Boolean(_vm.propertyContract.quitDate < _vm.form.endDate)
                 : true;
             },

             message: '结束日期必须小于等于业主合约合约到期日',
           } ]}}),_c('van-field',{attrs:{"readonly":"","clickable":"","disabled":Boolean(
             (_vm.$route.query.contractId &&
               (_vm.form.status == 3 || _vm.form.type == 4)) ||
               _vm.$route.query.transferContractId
           ),"required":"","name":"payMonth","value":!_vm.form.payMonth && !_vm.form.depositMonth
             ? ''
             : _vm.form.payMonth == 999
             ? '全额付'
             : '付' + _vm.form.payMonth + '押' + _vm.form.depositMonth,"label":"支付方式","placeholder":"点击选择>","rules":[
           {
             validator: function (item) {
               return Boolean(_vm.form.leaseMonth || _vm.form.leaseDay);
             },

             message: '请先选择租期',
           },

           {
             validator: function (item) {
               return Boolean(_vm.form.payMonth);
             },

             message: '请选择支付方式',
           } ]},on:{"click":function (item) {
             if (
               !Boolean(
                 (_vm.$route.query.contractId &&
                   (_vm.form.status == 3 || _vm.form.type == 4)) ||
                   _vm.$route.query.transferContractId
               )
             ) {
               _vm.form.leaseMonth || _vm.form.leaseDay ? (_vm.showPayType = true) : '';
             }
           }}}),_c('van-field',{attrs:{"name":"rental","type":"digit","disabled":"","label":"租金","placeholder":"点击填写"},model:{value:(_vm.form.rental),callback:function ($$v) {_vm.$set(_vm.form, "rental", $$v)},expression:"form.rental"}}),(_vm.form.activityId)?_c('van-field',{attrs:{"name":"activityRental","type":"number","disabled":"","label":"活动价格"},model:{value:(_vm.form.activityRental),callback:function ($$v) {_vm.$set(_vm.form, "activityRental", $$v)},expression:"form.activityRental"}}):_vm._e(),_c('van-field',{attrs:{"name":"deposit","type":"digit","label":"押金","placeholder":"点击填写","disabled":_vm.form.type == 4 || _vm.form.status == 3 || !_vm.depositInputEnabled,"rules":[
           {
             validator: function (item) {
               return Boolean(_vm.form.deposit);
             },
             message: '请填写押金',
           },

           {
             validator: _vm.validNum0,

             message: '押金必须为正整数或0',
           },

           {
             validator: _vm.validDeposit,

             message: '押金必须大于或等于支付方式对应的押金金额',
           } ]},model:{value:(_vm.form.deposit),callback:function ($$v) {_vm.$set(_vm.form, "deposit", $$v)},expression:"form.deposit"}}),_c('van-field',{attrs:{"name":"amount","type":"digit","disabled":"","label":"定金","placeholder":""},model:{value:(_vm.form.amount),callback:function ($$v) {_vm.$set(_vm.form, "amount", $$v)},expression:"form.amount"}}),_c('van-field',{attrs:{"name":"advanceFee","label":"水电燃预缴费","type":"digit","required":"","placeholder":"点击填写","disabled":Boolean(
             (_vm.$route.query.contractId &&
               (_vm.form.status == 3 || _vm.form.type == 4)) ||
               !_vm.prepayment.isUpdate
           ),"rules":[
           {
             validator: function (item) {
               return item !== '';
             },

             message: '请填写水电燃预缴费',
           },
           {
             validator: _vm.advanceFeeValid1,

             message: '水电燃预缴费不能为0',
           },
           {
             validator: _vm.advanceFeeValid2,

             message: ("水电燃预缴费必须为" + (this.prepayment.basePrice) + "的整数倍"),
           } ]},model:{value:(_vm.form.advanceFee),callback:function ($$v) {_vm.$set(_vm.form, "advanceFee", $$v)},expression:"form.advanceFee"}}),_c('van-field',{attrs:{"name":"serviceFee","label":"服务费","type":"digit","placeholder":"点击填写","disabled":Boolean(
             (_vm.$route.query.contractId &&
               (_vm.form.status == 3 || _vm.form.type == 4)) ||
               _vm.$route.query.transferContractId
           )},model:{value:(_vm.form.serviceFee),callback:function ($$v) {_vm.$set(_vm.form, "serviceFee", $$v)},expression:"form.serviceFee"}}),_c('van-field',{attrs:{"name":"condoFee","label":"物业费","type":"digit","required":"","placeholder":"点击填写","disabled":Boolean(
             (_vm.$route.query.contractId &&
               (_vm.form.status == 3 || _vm.form.type == 4)) ||
               _vm.$route.query.transferContractId
           ),"rules":[
           {
             validator: function (item) {
               return item !== '';
             },

             message: '请填写物业费',
           },

           {
             validator: _vm.validNum0Decimal2,

             message: '物业费必须大于等于0且最多保留两位小数',
           } ]},model:{value:(_vm.form.condoFee),callback:function ($$v) {_vm.$set(_vm.form, "condoFee", $$v)},expression:"form.condoFee"}}),_c('van-field',{attrs:{"border":false,"readonly":"","label":"其他费用"}}),_c('div',{staticClass:"field"},[_vm._v(" 一次性费用 "),_c('span',{staticClass:"button-mini"},[_c('van-icon',{attrs:{"name":"plus"},on:{"click":function (item) {
                 if (
                   !Boolean(
                     (_vm.$route.query.contractId &&
                       (_vm.form.status == 3 || _vm.form.type == 4)) ||
                       _vm.$route.query.transferContractId
                   )
                 ) {
                   _vm.showFeeS = true;

                   _vm.amountType = 1;
                 }
               }}})],1)]),_vm._l((_vm.form.singleMatterList),function(item,index){return _c('div',{key:item.matterId,staticClass:"unit"},[_c('van-field',{attrs:{"label":item.matterName,"type":"digit","placeholder":"点击填写","disabled":Boolean(
               (_vm.$route.query.contractId &&
                 (_vm.form.status == 3 || _vm.form.type == 4)) ||
                 _vm.$route.query.transferContractId
             ),"rules":[{ required: true, message: '请填写' + item.matterName }]},model:{value:(item.amount),callback:function ($$v) {_vm.$set(item, "amount", $$v)},expression:"item.amount"}}),_c('div',{staticClass:"after"},[_vm._v("元")]),_c('div',{staticClass:"after"},[_c('button',{staticClass:"sub",attrs:{"disabled":Boolean(
                 (_vm.$route.query.contractId &&
                   (_vm.form.status == 3 || _vm.form.type == 4)) ||
                   _vm.$route.query.transferContractId
               )},on:{"click":function($event){return _vm.subAmountS(index)}}})])],1)}),_c('div',{staticClass:"field"},[_vm._v(" 周期性费用 "),_c('span',{staticClass:"button-mini"},[_c('van-icon',{attrs:{"name":"plus"},on:{"click":function (item) {
                 if (
                   !Boolean(
                     (_vm.$route.query.contractId &&
                       (_vm.form.status == 3 || _vm.form.type == 4)) ||
                       _vm.$route.query.transferContractId
                   )
                 ) {
                   _vm.showFeeP = true;

                   _vm.amountType = 0;
                 }
               }}})],1)]),_vm._l((_vm.form.periodMatterList),function(item,index){return _c('div',{key:item.matterId,staticClass:"unit"},[_c('van-field',{attrs:{"label":item.matterName,"type":"digit","placeholder":"点击填写","disabled":Boolean(
               (_vm.$route.query.contractId &&
                 (_vm.form.status == 3 || _vm.form.type == 4)) ||
                 _vm.$route.query.transferContractId
             ),"rules":[{ required: true, message: '请填写' + item.matterName }]},model:{value:(item.amount),callback:function ($$v) {_vm.$set(item, "amount", $$v)},expression:"item.amount"}}),_c('div',{staticClass:"after"},[_vm._v("元/月")]),_c('div',{staticClass:"after"},[_c('button',{staticClass:"sub",attrs:{"disabled":Boolean(
                 (_vm.$route.query.contractId &&
                   (_vm.form.status == 3 || _vm.form.type == 4)) ||
                   _vm.$route.query.transferContractId
               )},on:{"click":function($event){return _vm.subAmountP(index)}}})])],1)})],2),_c('div',{staticStyle:{"height":"1.2rem"}}),_c('div',{staticClass:"btn"},[_c('van-button',{attrs:{"round":"","block":"","type":"primary"},on:{"click":function($event){_vm.active = 0;}}},[_vm._v("上一步")]),_c('van-button',{attrs:{"round":"","block":"","type":"primary"},on:{"click":_vm.next2}},[_vm._v("下一步")])],1)],1):_vm._e(),(_vm.active === 2)?_c('div',{staticClass:"form3"},[_vm._l((_vm.assetsData),function(item){return _c('div',{key:item.no},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"iconfont iconbookmark"}),_vm._v(" "+_vm._s(item.no === "Pub" ? "公区" : item.no)+"  ")]),_c('div',{staticClass:"assetsBody"},_vm._l((item.assets),function(assets){return _c('div',{key:assets.assetsId,on:{"click":function($event){return _vm.lookAssets(assets)}}},[_vm._v(" "+_vm._s(assets.materialTypeName)+" ")])}),0)])}),(!_vm.assetsData.length)?_c('van-empty',{attrs:{"description":"暂无资产"}}):_vm._e(),_c('div',{staticStyle:{"height":"1.2rem"}}),_c('div',{staticClass:"btn"},[_c('van-button',{attrs:{"round":"","block":"","type":"primary"},on:{"click":function($event){_vm.active = 1}}},[_vm._v("上一步")]),_c('van-button',{attrs:{"round":"","block":"","type":"primary"},on:{"click":_vm.next3}},[_vm._v("下一步")])],1)],2):_vm._e(),(_vm.active === 3)?_c('div',{staticClass:"form4"},[_c('van-form',{ref:"form4"},[_c('div',{staticClass:"field van-cell--required"},[_vm._v("电度数")]),_c('div',{staticClass:"body"},[(!_vm.existEle)?_c('div',{staticClass:"picCard"},[_c('div',{staticClass:"text"},[_vm._v("电峰")]),_c('van-uploader',{attrs:{"before-read":_vm.beforeRead,"after-read":function (item) {
                 _vm.electricMaxUrl = [
                   {
                     url: _vm.upload_qiniu_addr + item.file.key,

                     isImage: true,
                   } ];

                 _vm.$refs.form4.resetValidation('electricMaxUrl');
               },"max-count":1},model:{value:(_vm.electricMaxUrl),callback:function ($$v) {_vm.electricMaxUrl=$$v},expression:"electricMaxUrl"}}),_c('div',{staticClass:"text textBorder"},[_c('van-field',{attrs:{"type":"number","name":"electricMaxUrl","maxlength":"11","border":"","placeholder":'当前:' + _vm.houseDegrees.lastElectricMax,"rules":[
                 {
                   validator: function (item) {
                     return Boolean(_vm.electricMaxUrl.length) || !_vm.imgUp;
                   },

                   message: '请上传电峰图',
                 },

                 { required: true, message: '请请输入电峰' },

                 {
                   validator: _vm.validNum0Decimal2,

                   message: '电峰必须为正数或0，且最多保留两位小数',
                 } ]},on:{"input":function($event){_vm.form.electricTotal = _vm.accAdd(
                   _vm.form.electricMin,

                   _vm.form.electricMax
                 )}},model:{value:(_vm.form.electricMax),callback:function ($$v) {_vm.$set(_vm.form, "electricMax", $$v)},expression:"form.electricMax"}})],1)],1):_vm._e(),(!_vm.existEle)?_c('div',{staticClass:"picCard"},[_c('div',{staticClass:"text"},[_vm._v("电谷")]),_c('van-uploader',{attrs:{"before-read":_vm.beforeRead,"after-read":function (item) {
                 _vm.electricMinUrl = [
                   {
                     url: _vm.upload_qiniu_addr + item.file.key,

                     isImage: true,
                   } ];

                 _vm.$refs.form4.resetValidation('electricMinUrl');
               },"max-count":1},model:{value:(_vm.electricMinUrl),callback:function ($$v) {_vm.electricMinUrl=$$v},expression:"electricMinUrl"}}),_c('div',{staticClass:"text textBorder"},[_c('van-field',{attrs:{"type":"number","name":"electricMinUrl","maxlength":"11","placeholder":'当前:' + _vm.houseDegrees.lastElectricMin,"rules":[
                 {
                   validator: function (item) {
                     return Boolean(_vm.electricMinUrl.length) || !_vm.imgUp;
                   },

                   message: '请上传电谷图',
                 },

                 { required: true, message: '请输入电谷' },

                 {
                   validator: _vm.validNum0Decimal2,

                   message: '电谷必须为正数或0，且最多保留两位小数',
                 } ]},on:{"input":function($event){_vm.form.electricTotal = _vm.accAdd(
                   _vm.form.electricMin,

                   _vm.form.electricMax
                 )}},model:{value:(_vm.form.electricMin),callback:function ($$v) {_vm.$set(_vm.form, "electricMin", $$v)},expression:"form.electricMin"}})],1)],1):_vm._e(),(!_vm.existEle)?_c('div',{staticClass:"picCard"},[_c('div',{staticClass:"text"},[_vm._v("电总")]),_c('van-uploader',{attrs:{"before-read":_vm.beforeRead,"after-read":function (item) {
                 _vm.electricTotalUrl = [
                   {
                     url: _vm.upload_qiniu_addr + item.file.key,

                     isImage: true,
                   } ];

                 _vm.$refs.form4.resetValidation('electricTotalUrl');
               },"max-count":1},model:{value:(_vm.electricTotalUrl),callback:function ($$v) {_vm.electricTotalUrl=$$v},expression:"electricTotalUrl"}}),_c('div',{staticClass:"text textBorder"},[_c('van-field',{attrs:{"type":"number","name":"electricTotalUrl","maxlength":"11","placeholder":'当前:' + _vm.houseDegrees.lastElectricTotal,"rules":[
                 { required: true, message: '请输入电总' },

                 {
                   validator: _vm.validNum0Decimal2,

                   message: '电总必须为正数或0，且最多保留两位小数',
                 },

                 {
                   validator: function (item) {
                     return !(
                       _vm.form.electricTotal < _vm.houseDegrees.lastElectricTotal && _vm.$store.state.user.companyId!='1939993008395112449'
                     );
                   },

                   message: ("电总度数必须大于当前房源" + (_vm.houseDegrees.lastElectricTotal)),
                 },

                 {
                   validator: function (item) {
                     return Boolean(_vm.electricTotalUrl.length) || !_vm.imgUp;
                   },

                   message: '请上传电总图',
                 } ]},model:{value:(_vm.form.electricTotal),callback:function ($$v) {_vm.$set(_vm.form, "electricTotal", $$v)},expression:"form.electricTotal"}})],1)],1):_vm._e(),(_vm.existEle)?_c('div',{staticStyle:{"padding":"0.26667rem 0.42667rem"}},[_vm._v(" 提示：该房源已安装智能电表，无需上传图片及度数 ")]):_vm._e()]),_c('div',{staticClass:"field van-cell--required"},[_vm._v("水度数")]),_c('div',{staticClass:"body"},[(!_vm.existWater)?_c('div',{staticClass:"picCard"},[_c('van-uploader',{attrs:{"before-read":_vm.beforeRead,"after-read":function (item) {
                 _vm.waterUrl = [
                   {
                     url: _vm.upload_qiniu_addr + item.file.key,

                     isImage: true,
                   } ];

                 _vm.$refs.form4.resetValidation('waterUrl');
               },"max-count":1},model:{value:(_vm.waterUrl),callback:function ($$v) {_vm.waterUrl=$$v},expression:"waterUrl"}}),_c('div',{staticClass:"text textBorder"},[_c('van-field',{attrs:{"type":"number","name":"waterUrl","maxlength":"11","placeholder":'当前:' + _vm.houseDegrees.lastWater,"rules":[
                 { required: true, message: '请输入水度数' },

                 {
                   validator: _vm.validNum0Decimal2,

                   message: '水度数必须为正数或0，且最多保留两位小数',
                 },

                 {
                   validator: function (item) {
                     return !(_vm.form.water < _vm.houseDegrees.lastWater&& _vm.$store.state.user.companyId!='1939993008395112449');
                   },

                   message: ("水度数必须大于当前房源" + (_vm.houseDegrees.lastWater)),
                 },

                 {
                   validator: function (item) {
                     return Boolean(_vm.waterUrl.length) || !_vm.imgUp;
                   },

                   message: '请上传水图',
                 } ]},model:{value:(_vm.form.water),callback:function ($$v) {_vm.$set(_vm.form, "water", $$v)},expression:"form.water"}})],1)],1):_vm._e(),(_vm.existWater)?_c('div',{staticStyle:{"padding":"0.26667rem 0.42667rem"}},[_vm._v(" 提示：该房源已安装智能水表，无需上传图片及度数 ")]):_vm._e()]),_c('div',{staticClass:"field van-cell--required"},[_vm._v("燃气度数")]),_c('div',{staticClass:"body"},[_c('div',{staticClass:"picCard textBorder"},[_c('van-uploader',{attrs:{"before-read":_vm.beforeRead,"after-read":function (item) {
                 _vm.gasUrl = [
                   {
                     url: _vm.upload_qiniu_addr + item.file.key,

                     isImage: true,
                   } ];

                 _vm.$refs.form4.resetValidation('gasUrl');
               },"max-count":1},model:{value:(_vm.gasUrl),callback:function ($$v) {_vm.gasUrl=$$v},expression:"gasUrl"}}),_c('div',{staticClass:"text textBorder"},[_c('van-field',{attrs:{"type":"number","name":"gasUrl","maxlength":"11","placeholder":'当前:' + _vm.houseDegrees.lastGas,"rules":[
                 { required: true, message: '请输入燃气度数' },

                 {
                   validator: _vm.validNum0Decimal2,

                   message: '燃气度数必须为正数或0，且最多保留两位小数',
                 },

                 {
                   validator: function (item) {
                     return !(_vm.form.gas < _vm.houseDegrees.lastGas && _vm.$store.state.user.companyId!='1939993008395112449');
                   },

                   message: ("燃气度数必须大于当前房源" + (_vm.houseDegrees.lastGas)),
                 },

                 {
                   validator: function (item) {
                     return Boolean(_vm.gasUrl.length) || !_vm.imgUp;
                   },

                   message: '请上传燃气图',
                 } ]},model:{value:(_vm.form.gas),callback:function ($$v) {_vm.$set(_vm.form, "gas", $$v)},expression:"form.gas"}})],1)],1)]),_c('div',{staticClass:"field"},[_vm._v("其它")]),_c('div',{staticClass:"body body1"},[_c('van-uploader',{attrs:{"before-read":_vm.beforeRead,"after-read":function (item) {
               _vm.otherUrl.pop();

               _vm.otherUrl.push({
                 url: _vm.upload_qiniu_addr + item.file.key,

                 isImage: true,
               });
             },"max-count":9},model:{value:(_vm.otherUrl),callback:function ($$v) {_vm.otherUrl=$$v},expression:"otherUrl"}})],1)]),_c('div',{staticStyle:{"height":"1.2rem"}}),_c('div',{staticClass:"btn"},[_c('van-button',{attrs:{"round":"","block":"","type":"primary"},on:{"click":function($event){_vm.active = 2}}},[_vm._v("上一步")]),_c('van-button',{attrs:{"round":"","block":"","type":"primary","loading":_vm.saveLoad,"disabled":_vm.saveLoad},on:{"click":_vm.next4}},[_vm._v("保存")])],1)],1):_vm._e(),_c('transition',{attrs:{"name":"van-slide-right"}},[(_vm.showHouse)?_c('div',{staticClass:"search"},[_c('form',{attrs:{"action":"/"}},[_c('van-search',{attrs:{"shape":"round","show-action":"","placeholder":"请输入房源地址搜索"},on:{"input":_vm.onSearchHouse,"search":_vm.onSearchHouse,"cancel":_vm.onCancel},model:{value:(_vm.searchValueHouse),callback:function ($$v) {_vm.searchValueHouse=$$v},expression:"searchValueHouse"}})],1),_vm._l((_vm.houseList),function(house){return _c('van-cell',{key:house.id,attrs:{"title":house.number + ' | ' + house.address,"icon":"wap-home-o"},on:{"click":function($event){return _vm.changeHouse(house)}}})}),(_vm.searchLoad)?_c('van-loading',{attrs:{"size":"24"}}):(_vm.searchValueHouse && !_vm.houseList.length)?_c('div',[_vm._v("暂无数据")]):_vm._e()],2):_vm._e()]),_c('transition',{attrs:{"name":"van-slide-right"}},[(_vm.showCustomer)?_c('div',{staticClass:"search"},[_c('form',{attrs:{"action":"/"}},[_c('van-search',{attrs:{"shape":"round","show-action":"","placeholder":"请输入手机号搜索"},on:{"input":_vm.onSearchCustomer,"search":_vm.onSearchCustomer,"cancel":_vm.onCancel},model:{value:(_vm.searchValueCustomer),callback:function ($$v) {_vm.searchValueCustomer=$$v},expression:"searchValueCustomer"}})],1),_vm._l((_vm.customerList),function(customer){return _c('van-cell',{key:customer.id,attrs:{"title":customer.name + '-' + customer.phone,"icon":"user-o"},on:{"click":function($event){return _vm.changeCustomer(customer)}}})}),(_vm.searchLoad)?_c('van-loading',{attrs:{"size":"24"}}):(_vm.searchValueCustomer && !_vm.customerList.length)?_c('div',[_vm._v(" 暂无数据 ")]):_vm._e()],2):_vm._e()]),_c('transition',{attrs:{"name":"van-slide-right"}},[(_vm.showCheckPerson)?_c('div',{staticClass:"search"},[_c('form',{attrs:{"action":"/"}},[_c('van-search',{attrs:{"shape":"round","show-action":"","placeholder":"请输入手机号搜索"},on:{"input":_vm.onSearchCheckPerson,"search":_vm.onSearchCheckPerson,"cancel":_vm.onCancel},model:{value:(_vm.searchValueCheckPerson),callback:function ($$v) {_vm.searchValueCheckPerson=$$v},expression:"searchValueCheckPerson"}})],1),_vm._l((_vm.checkPersonList),function(checkPerson){return _c('van-cell',{key:checkPerson.id,attrs:{"title":checkPerson.name + '-' + checkPerson.phone,"icon":"user-o"},on:{"click":function($event){return _vm.changeCheckPerson(checkPerson)}}})}),(_vm.searchLoad)?_c('van-loading',{attrs:{"size":"24"}}):(_vm.searchValueCheckPerson && !_vm.checkPersonList.length)?_c('div',[_vm._v(" 暂无数据 ")]):_vm._e()],2):_vm._e()]),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showIdType),callback:function ($$v) {_vm.showIdType=$$v},expression:"showIdType"}},[_c('van-picker',{attrs:{"show-toolbar":"","columns":_vm.form.customerType == '1' ? _vm.idTypeList1 : ['社会信用代码']},on:{"confirm":function (item, index) {
           _vm.form.customerType == '1'
             ? (_vm.form.idType = index / 1 + 1)
             : (_vm.form.idType = 6);

           _vm.showIdType = false;

           _vm.$refs.form1.resetValidation('idNo');
         },"cancel":function($event){_vm.showIdType = false}}})],1),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showContact),callback:function ($$v) {_vm.showContact=$$v},expression:"showContact"}},[_c('van-picker',{attrs:{"show-toolbar":"","columns":_vm.contactList},on:{"confirm":function (item, index) {
           _vm.form.contactRelation = index / 1 + 1;

           _vm.showContact = false;
         },"cancel":function($event){_vm.showContact = false}}})],1),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showIdType1),callback:function ($$v) {_vm.showIdType1=$$v},expression:"showIdType1"}},[_c('van-picker',{attrs:{"show-toolbar":"","columns":_vm.idTypeList1},on:{"confirm":_vm.changePersonType,"cancel":function($event){_vm.showIdType1 = false}}})],1),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showStartDate),callback:function ($$v) {_vm.showStartDate=$$v},expression:"showStartDate"}},[_c('van-datetime-picker',{attrs:{"type":"date","min-date":_vm.startRangeDate,"max-date":_vm.endRangeDate},on:{"confirm":_vm.startDateConfirm,"cancel":function($event){_vm.showStartDate = false}},model:{value:(_vm.currentDate),callback:function ($$v) {_vm.currentDate=$$v},expression:"currentDate"}})],1),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showPayType),callback:function ($$v) {_vm.showPayType=$$v},expression:"showPayType"}},[_c('van-picker',{attrs:{"show-toolbar":"","value-key":"label","columns":_vm.payTypeList},on:{"confirm":_vm.onConfirm,"cancel":function($event){_vm.showPayType = false}}})],1),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showFeeS),callback:function ($$v) {_vm.showFeeS=$$v},expression:"showFeeS"}},[_c('van-picker',{attrs:{"show-toolbar":"","value-key":"name","columns":_vm.matterListS},on:{"confirm":_vm.addAmountS,"cancel":function($event){_vm.showFeeS = false}}})],1),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showFeeP),callback:function ($$v) {_vm.showFeeP=$$v},expression:"showFeeP"}},[_c('van-picker',{attrs:{"show-toolbar":"","value-key":"name","columns":_vm.matterListP},on:{"confirm":_vm.addAmountP,"cancel":function($event){_vm.showFeeP = false}}})],1),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showActivity),callback:function ($$v) {_vm.showActivity=$$v},expression:"showActivity"}},[_c('van-picker',{attrs:{"show-toolbar":"","value-key":"name","columns":_vm.activityList},on:{"confirm":function (item,index){
         _vm.changeActivity(item)
       },"cancel":function($event){_vm.showActivity = false}}})],1),_c('van-dialog',{attrs:{"title":"资产详情","show-cancel-button":"","showConfirmButton":false,"showCancelButton":false,"closeOnClickOverlay":true},model:{value:(_vm.showAssets),callback:function ($$v) {_vm.showAssets=$$v},expression:"showAssets"}},[_c('van-cell',{attrs:{"title":"名称","value":_vm.asstesDetail.materialTypeName}}),_c('van-cell',{attrs:{"title":"品类","value":_vm.asstesDetail.materialTypeParentName}}),_c('van-cell',{attrs:{"title":"规格","value":_vm.asstesDetail.specification}}),_c('van-cell',{attrs:{"title":"品牌","value":_vm.asstesDetail.brand}}),_c('van-cell',{attrs:{"title":"型号","value":_vm.asstesDetail.model}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }